<span *ngIf="situacao"
      class="inline-flex items-center gap-1.5 rounded-full px-3 py-0.5 md:py-1 text-sm font-semibold text-white whitespace-nowrap max-w-full"
      [ngClass]="config.classes"
      [title]="config.texto">
  <lucide-icon [name]="config.icone" [class.animate-spin]="situacao === 'EM_ANDAMENTO'" class="w-4 h-4 shrink-0"></lucide-icon>
  <span class="truncate">{{ config.texto }}</span>
</span>
<span *ngIf="!situacao" class="text-gray-400 dark:text-gray-500 text-sm">-</span>